import { Component, EventEmitter, inject, Input, Output } from '@angular/core';

import { TranslationService } from 'app/core/internationalization/translation.service';

export type SSO_PROVIDER = 'Google';

const SSO_PROVIDER_LOOKUP: Record<SSO_PROVIDER, string> = {
  Google: 'sso-providers/google.svg'
};

@Component({
  selector: 'kh-sso-provider-button',
  styleUrls: ['./sso-provider-button.component.less'],
  templateUrl: './sso-provider-button.component.html',
  standalone: false
})
export class SSOProviderButtonComponent {
  private readonly _translationService = inject(TranslationService);

  @Input() public provider: SSO_PROVIDER = 'Google';
  @Output() public providerClick = new EventEmitter<SSO_PROVIDER>();
  public buttonText: string;
  public logo: string;

  public constructor() {
    this.buttonText = this._translationService.instant('SSO_PROVIDER_BUTTON.LOG_IN_WITH_PROVIDER', { Provider: this.provider });
    this.logo = 'sso-providers/google.svg';
  }

  public onClick(): void {
    this.providerClick.next(this.provider);
  }
}
